import { z } from 'zod';
import { placeSchema, type Place } from './collection-place.contract';

const PLACE_TTL_MS = 24 * 60 * 60_000;
const STORAGE_PREFIX = 'collection-place:declared:';
const storedPlaceSchema = z.object({
  place: placeSchema,
  expiresAt: z.number().int().positive(),
}).strict();

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}${encodeURIComponent(userId)}`;
}

export function readDeclaredPlace(userId: string): Place | undefined {
  try {
    const serialized = window.sessionStorage.getItem(storageKey(userId));
    if (!serialized) return undefined;
    const value: unknown = JSON.parse(serialized);
    const parsed = storedPlaceSchema.safeParse(value);
    if (!parsed.success || parsed.data.expiresAt <= Date.now()) {
      window.sessionStorage.removeItem(storageKey(userId));
      return undefined;
    }
    return parsed.data.place;
  } catch {
    return undefined;
  }
}

export function saveDeclaredPlace(userId: string, place: Place): void {
  try {
    window.sessionStorage.setItem(storageKey(userId), JSON.stringify({ place, expiresAt: Date.now() + PLACE_TTL_MS }));
  } catch {
    return;
  }
}

export function clearDeclaredPlace(userId: string): void {
  try {
    window.sessionStorage.removeItem(storageKey(userId));
  } catch {
    return;
  }
}
